// packages block
import { Dialog } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import React from "react";
// common block
import "./style.css";
import { preaddStyles } from "./styles";
import { FormButton } from "../form/button";
import { AddBankForm } from "./addBankForm";
// constants, theme, utils and api block
import { BLUE_EIGHT, ORANGE_TWO, WHITE } from "../../theme";
import { PreDialogHeader } from "./preDialogHeader";
import { useReducer } from "react";
import { AddBankSelectForm } from "./addBankSelectForm";
import { useEffect } from "react";

export const AddBankSelectDialog = ({
  setBankValue,
  setIsAddBankDialogVisible,
  banksData,
  title,
  open,
  handleClose,
}) => {
  const classes = preaddStyles();
  const { t } = useTranslation();

  const [{ bankSelector }, setData]
    = useReducer((state, newState) => ({ ...state, ...newState }), { bankSelector: banksData[0]?.id });

  setBankValue(banksData[0]?.id)
  const handleChange = (prop) => (event) => {
    setData({ [prop]: event.target.value });
    setBankValue(event.target.value)
  }

  const close = () => {
    setIsAddBankDialogVisible(false)
  };

  const handleClick = () => {
    handleClose();
  };

  return (
    <Dialog
      className={classes.root}
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
    >
      <div className={classes.mainContainer}>
        <PreDialogHeader backbut={true} title={title} handleClose={handleClose} />

        <div className={classes.dropContainer}>
          <AddBankSelectForm
            banksData={banksData}
            bankSelector={bankSelector}
            handleChange={handleChange}
          />
        </div>

        <div className={classes.addBankdialogFooter}>
          {/* <div className={classes.footerButton}>
            <FormButton
              title={t("text_cancel")}
              borderColor={ORANGE_TWO}
              titleColor={WHITE}
              hoverTitleColor={ORANGE_TWO}
              hoverBorderColor={ORANGE_TWO}
              backgroundColor={ORANGE_TWO}
              hoverBackgroundColor={WHITE}
              onClickHandler={close}
              height={40}
              width={"10vw"}
              borderTopRightRadius={15}
              borderTopLeftRadius={15}
              borderBottomLeftRadius={15}
              borderBottomRightRadius={15}
              style={{ textTransform: "none", fontSize: "0.8vw", fontWeight: "700" }}
            />
          </div> */}

          <div className={classes.footerButton}>
            <FormButton
              borderColor={BLUE_EIGHT}
              titleColor={BLUE_EIGHT}
              hoverTitleColor={WHITE}
              hoverBorderColor={BLUE_EIGHT}
              backgroundColor={WHITE}
              hoverBackgroundColor={BLUE_EIGHT}
              style={{ textTransform: "none", fontSize: "0.8vw", fontWeight: "700", padding: 0 }}
              title={t("text_continue")}
              onClickHandler={handleClick}
              height={40}
              width={"10vw"}
              borderTopRightRadius={15}
              borderTopLeftRadius={15}
              borderBottomLeftRadius={15}
              borderBottomRightRadius={15}
            />
          </div>
        </div>
      </div>
    </Dialog>
  );
};
